export const noteColors = [
  "#e0e0e0",
  "#fac1d6",
  "#faa09e",
  "#f6ca92",
  "#8ab9f6",
];
